import { Colors } from "../../consts/Colors";
import FONTS from "../../consts/Fonts";
import { tags } from "../../consts/Tags";
import ButtonRounded from "../global/buttons/ButtonRounded";

export default class DebriefPanel extends Phaser.GameObjects.Container {
   constructor(scene) {
      super(scene, 0, 0, []);

      this.soundManager = scene.soundManager

      this.scene = scene;
      scene.add.existing(this);

      // Ajout du fond
      let background = this.scene.add.rectangle(0, 0, 800, this.scene.height, Colors.Elmt.LightGrey).setOrigin(0);
      this.add(background);

      // Ajout de la bande
      let bande = this.scene.add.rectangle(0, 0, 80, background.height, Colors.Elmt.Blue).setOrigin(0);
      this.add(bande);

      // Ajout du titre
      let debrief = this.scene.add.text(160, 66, "DEBRIEF", {
         fontSize: '14px',
         fontFamily: FONTS.InterRegular,
         color: Colors.Text.Blue
      }).setOrigin(0)
      this.add(debrief);

      
      let line = this.scene.add.rectangle(160, 112, 560, 1, Colors.Elmt.DarkGrey).setOrigin(0);
      this.add(line);

      // Ajout du texte
      const configText = {
         fontSize: '24px',
         fontFamily: FONTS.Inter24Medium,
         color: Colors.Text.Black
      }
      const configTitre = {
         fontSize: '24px',
         fontFamily: FONTS.Inter24Bold,
         color: Colors.Text.Black,
         background: 'transparent',
         tags: tags,
         wordWrap: { width: 560 }
      }

      let txt = "L’identification d’une vidéo générée par IA repose sur <class=\"orange\">l’observation d’indices visuels</class> et sur <class=\"orange\">la compréhension des évolutions technologiques.</class>"
      let text = this.scene.add.rexTagText(160, 140, txt, configTitre).setOrigin(0).setWordWrapWidth(560);
      this.add(text);

      let txts = [
         "Repérer des anomalies visuelles ou sonores permet d’identifier une vidéo générée par IA : déformations, mouvements étranges, objets incohérents ou décalage voix/lèvres. Un ou deux indices peuvent suffire à éveiller le doute, sans que leur absence garantisse l’authenticité.",
         "Comprendre l’évolution rapide de ces technologies est tout aussi essentiel : ce qui était évident hier ne l’est plus aujourd’hui. L’esprit critique reste donc le meilleur outil face aux vidéos générées par IA.",
      ]
      let Y = text.y + text.height + 24;
      txts.forEach((txt, index) => {

         let text = this.scene.add.text(160, Y, txt, configText).setOrigin(0).setWordWrapWidth(482);
         this.add(text);

         Y += text.height + 24;
      })

      // Ajout du bouton de fermeture
      let closeBtn = new ButtonRounded(this.scene, background.width/2 + bande.width/2, Y  + 48, {
         text: "Continuer",
         color: Colors.Elmt.Orange,
         textColor: Colors.Text.White,
         hoverColor: Colors.Elmt.Blue,
      })
      closeBtn.y += closeBtn.height/2;
      this.add(closeBtn);

      closeBtn.setClickFunction(() => {
         this.animOut(() => {
            this.scene.closeDebrief()
         })      
      })

      this.setSize(background.width, background.height);
   }

   animIn() {
      this.x = this.scene.width;

      this.soundManager.playOnce('PaperSlide4')
   
      this.scene.tweens.add({
         targets: this,
         x: this.scene.width - this.width,
         duration: 500,
         ease: 'Cubic.easeInOut'
       });

   }

   animOut(endFunc) {
      this.soundManager.playOnce('PaperSlide4')
      this.scene.tweens.add({
         targets: this,
         x: this.scene.width,
         duration: 500,
         ease: 'Cubic.easeInOut',
         onComplete: () => {
            // Animation complete
            if(endFunc) endFunc();
         }
       });
   }
}